<template>

    <div class="table">
        <table>

            <tr>
                <th class="th-center">DESCRIPTION</th>
                <th class="th-center">QIT</th>
                <th class="th-center">PRICE</th>
                <th class="th-center first ">TOTAL</th>
            </tr>

            <tr v-for="item in value" :key="item.name">
                <td class="td-center">{{item.name}}</td>
                <td class="td-center">{{item.quantity}}</td>
                <td class="td-center">$ {{item.price}}</td>
                <td class="td-center first ">$ {{item.quantity * item.price}}</td>
            </tr>

        </table>
    </div>

</template>


<script>
    export default {
        props: {
            value : {Array,Object,required:true}
        }

    }
</script>

<style scoped>
    .td-center {
        text-align: center;
    }

    .first {
        padding-right: 25px;
    }

    .table {
        margin-bottom: 30px;

    }

    th {
        color: rgba(0, 0, 0, 0.63);
        border-bottom: 3px solid #333333;
        font-weight: bold;
        font-size: 10px;
        height: 30px;
        padding-bottom: 3px;

    }

    td {
        font-weight: bold;
        padding: 10px 0 10px 0;
        font-size: 11px;
        text-align: center;
        align-content: center;
        align-items: center;
        border-bottom: 2px solid rgba(99, 99, 99, 0.09);

    }

    .td-first {
        text-align: left;
    }


    .td-end {
        color: rgb(230, 40, 15);
        text-align: right;
    }


    table {
        margin: 0 auto;
        width: 90%;
        border-collapse: collapse;

    }

    .th-first {
        text-align: left;
    }

    .th-end {
        text-align: end;
    }

    .td-by {
        font-size: 18px;
    }


</style>